import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import InViewObserver from 'components/InViewObserver';
// import { gaWrapper } from 'helpers/analytics';
import LinkList from 'components_v2/common/LinkList';
import s from './Infocus.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

// const sendGAEvent = title => {
//   gaWrapper('send', 'event', 'Budget Widget', `click`, title);
// };

const loadKeywordsData = (
  dataUrl,
  linksData,
  cardKeywordsFilter,
  setCardFiltersData,
  setDefaultCardFilter,
  isMobile,
) => {
  if (cardKeywordsFilter && dataUrl && !linksData) {
    makeRequest
      .get(dataUrl, { isMobile })
      .then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.content_json &&
          response.data.content_json.groups &&
          Array.isArray(response.data.content_json.groups)
        ) {
          try {
            setDefaultCardFilter(response.data.content_json.default);
            setCardFiltersData(response.data.content_json.groups);
          } catch (e) {
            // console.log(e);
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};

const componentRender = (linksData, heading, sectionName, className, ga4Data) =>
  linksData ? (
    <div className={`${s.inFocus} ${className}`}>
      {heading ? <div className={`${s.title}`}>{heading}:</div> : null}
      <div className={`${s.links}`}>
        <LinkList
          data={linksData}
          className=""
          showBlinker={false}
          ga4Data={ga4Data}
          newga={`click-${sectionName}-$index#`}
          ga4Type="in_focus_widget"
        />
      </div>
    </div>
  ) : (
    ''
  );

const Infocus = props => {
  const {
    title,
    data,
    className,
    secname,
    cardKeywordsFilter,
    dataUrl,
    csr,
    isMobile,
    ga4Data = null,
    sectitle,
  } = props;
  const [linksData, setLinksData] = useState(undefined);
  const [cardFiltersData, setCardFiltersData] = useState(undefined);
  const [defaultCardFilter, setDefaultCardFilter] = useState(undefined);

  useEffect(
    () => {
      if (
        cardFiltersData &&
        Array.isArray(cardFiltersData) &&
        cardKeywordsFilter
      ) {
        try {
          let filteredKeywordData = cardFiltersData.filter(
            filter =>
              filter.name &&
              filter.name.toLowerCase() === cardKeywordsFilter.toLowerCase(),
          );
          if (!filteredKeywordData.length && defaultCardFilter) {
            filteredKeywordData = cardFiltersData.filter(
              filter => filter.name && filter.name === defaultCardFilter,
            );
          }
          if (
            filteredKeywordData &&
            filteredKeywordData.length > 0 &&
            filteredKeywordData[0].links &&
            Array.isArray(filteredKeywordData[0].links)
          ) {
            setLinksData(
              filteredKeywordData[0].links.map(keyword => ({
                hl: keyword.label,
                wu: keyword.url,
              })),
            );
          } else {
            setLinksData(undefined);
          }
        } catch (e) {
          // console.log(e);
        }
      }
    },
    [cardKeywordsFilter, cardFiltersData],
  );

  const heading = title || (data && data.name);

  let links;
  if (data) {
    links = data && (Array.isArray(data) ? data : data.items);
  }

  if (!linksData && links) {
    setLinksData(links);
  }
  const sectionName = (secname || 'section').replace(/ /g, '');

  return csr ? (
    <InViewObserver
      inViewCallback={() => {
        loadKeywordsData(
          dataUrl,
          linksData,
          cardKeywordsFilter,
          setCardFiltersData,
          setDefaultCardFilter,
          isMobile,
        );
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: 'in_focus_widget',
          category: sectitle,
        });
      }}
      viewMargin="800px 0px 800px 0px"
    >
      {componentRender(
        linksData,
        heading,
        sectionName,
        className,
        ga4Data,
        sectitle,
      )}
    </InViewObserver>
  ) : (
    <InViewObserver
      inViewCallback={() => {
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: 'in_focus_widget',
          category: sectitle,
        });
      }}
    >
      {componentRender(
        linksData,
        heading,
        sectionName,
        className,
        ga4Data,
        sectitle,
      )}
    </InViewObserver>
  );
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

Infocus.propTypes = {
  data: PropTypes.shape({}),
  title: PropTypes.string,
  cardKeywordsFilter: PropTypes.string,
  dataUrl: PropTypes.string,
  csr: PropTypes.bool,
  isMobile: PropTypes.bool,
  sectitle: PropTypes.string,
};

Infocus.defaultProps = {
  data: undefined,
  title: '',
  cardKeywordsFilter: '',
  dataUrl: undefined,
  csr: false,
  isMobile: false,
  sectitle: '',
};

export default connect(mapStateToProps)(Infocus);
